import React, { useState } from "react";
import { useSelector } from "react-redux";
import useForm from "../../hooks/useForm";
import {
  AddExistingStudentService,
  SearchStudentService,
} from "../../services/competitions";
import { textIdentifier } from "../../textIdentifier";

const AddExistingStudent = ({ setShowAddStudentModal }) => {
  const [searchedStudent, setSearchedStudent] = useState(null);
  const { selectedClass,lang } = useSelector((state) => state.main);
  const [error,setError] = useState("");

  const handleSubmit = async (values) => {
    try {
      if (Object.keys(searchStudentForm.errors).length < 1) {
        const res = await SearchStudentService(values.email);
        setSearchedStudent(res.data);
      }
    } catch (error) {
      setError(error.data.message)
    }
  };

  const searchStudentForm = useForm({
    initialValues: {
      email: "",
    },
    validate: (values) => {
      const errors = {};
      if (!values.email.trim()) {
        errors.email = textIdentifier["please-enter-email"][lang];
      }
      if (error) {
        setError("")
      }
      if (searchedStudent) {
        setSearchedStudent(null)
      }
      return errors;
    },
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });

  const addStudentToClass = async () => {
    try {
      if (searchedStudent) {
        const data = {
          user_id: searchedStudent.id,
        };
        const res = await AddExistingStudentService(selectedClass.code, data);
        setShowAddStudentModal(false);
      }
    } catch (error) {
      console.error(error.message);
    }
  };

  return (
    <div id="AddExistingStudent" className="tabcontent">
      <form onSubmit={searchStudentForm.handleSubmit}>
        <div className="form-group">
          <div className="form-label">{textIdentifier["search-existing-student"][lang]}</div>
          <div
            className="cr-search-container d-flex w-100"
            style={{ border: "1px solid" }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                d="M19 19L13 13L19 19ZM15 8C15 8.91925 14.8189 9.82951 14.4672 10.6788C14.1154 11.5281 13.5998 12.2997 12.9497 12.9497C12.2997 13.5998 11.5281 14.1154 10.6788 14.4672C9.82951 14.8189 8.91925 15 8 15C7.08075 15 6.1705 14.8189 5.32122 14.4672C4.47194 14.1154 3.70026 13.5998 3.05025 12.9497C2.40024 12.2997 1.88463 11.5281 1.53284 10.6788C1.18106 9.82951 1 8.91925 1 8C1 6.14348 1.7375 4.36301 3.05025 3.05025C4.36301 1.7375 6.14348 1 8 1C9.85652 1 11.637 1.7375 12.9497 3.05025C14.2625 4.36301 15 6.14348 15 8Z"
                stroke="#2E2E2E"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <input
              className="form-control"
              placeholder={textIdentifier["search-by-email-ID"][lang]}
              name="email"
              id="email"
              disabled={searchStudentForm.isSubmitting}
              value={searchStudentForm.values.email}
              onChange={searchStudentForm.handleChange}
            />
          </div>

          {Object.values(searchStudentForm.errors).length > 0 && (
            <div id="helperText" className="form-text mt-1">
              {Object.values(searchStudentForm.errors)[0]}
            </div>
          )}

          {Boolean(error) && (
            <div id="helperText" className="form-text mt-1">
              {error}
            </div>
          )}
        </div>

        <div className="form-group d-flex justify-content-end">
          <button type="submit" className="btn-contained search-button">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                d="M19 19L13 13L19 19ZM15 8C15 8.91925 14.8189 9.82951 14.4672 10.6788C14.1154 11.5281 13.5998 12.2997 12.9497 12.9497C12.2997 13.5998 11.5281 14.1154 10.6788 14.4672C9.82951 14.8189 8.91925 15 8 15C7.08075 15 6.1705 14.8189 5.32122 14.4672C4.47194 14.1154 3.70026 13.5998 3.05025 12.9497C2.40024 12.2997 1.88463 11.5281 1.53284 10.6788C1.18106 9.82951 1 8.91925 1 8C1 6.14348 1.7375 4.36301 3.05025 3.05025C4.36301 1.7375 6.14348 1 8 1C9.85652 1 11.637 1.7375 12.9497 3.05025C14.2625 4.36301 15 6.14348 15 8Z"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <span className="mx-2">{textIdentifier["search"][lang]}</span>
          </button>
        </div>

        {searchedStudent && (
        <div className="form-group my-5">
          <h5 className="mb-3">{textIdentifier["search-result"][lang]}:</h5>
            <h5>
              {searchedStudent?.first_name} {searchedStudent?.last_name}{" "}
              {`(${searchedStudent?.email})`}
            </h5>
            </div>
        )}

        <div className="form-group btn-container">
          <button
            type="button"
            className="btn-outlined w-50"
            onClick={() => setShowAddStudentModal(false)}
          >
          {textIdentifier["cancel"][lang]}
          </button>
          <button
            type="button"
            className="btn-contained w-50"
            onClick={addStudentToClass}
          >
            {textIdentifier["add"][lang]}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddExistingStudent;
